export default "__VITE_ASSET__38a91f30__"